<template lang="pug">
  section
    hr

    h3.heading Program Progress
    .program-heading
      button(@click="showDep = !showDep" v-bind:class="{ 'active': showDep }") Depression Management Program
      .program-progress
        p
          strong 75%
          | Complete
        .bar
          span.complete(style="width: 75%")
    transition(name="slide-fade")
      .program-content(v-if="showDep")
        .series-overview
          h3 Recognizing Your Depressive thoughts
          p Learn how to recognize depressive thinking cycles and begin to challenge them.
        ul.series-list
          li
            article.activity
              .ribbon-wrapper
                .ribbon.skipped Skipped
              img.activity-thumb(src="http://via.placeholder.com/200x200&text=Img" alt="Activity thumbnail")
              h2 What is depressive thinking?
              p Sometimes your thoughts might feel like an avalanche of negativity. Have you ever wondered why? Here are some tools to stop them.
          li
            article.activity
              .ribbon-wrapper
                .ribbon Completed
              img.activity-thumb(src="http://via.placeholder.com/200x200&text=Img" alt="Activity thumbnail")
              h2 Using the thoughts and feelings log
              p Thoughts on autopilot can trap you in a negative cycle. Learn how to slow down, understand and question these thoughts.
          li
            article.activity
              .ribbon-wrapper
                .ribbon Completed
              img.activity-thumb(src="http://via.placeholder.com/200x200&text=Img" alt="Activity thumbnail")
              h2 Action plan and summary
              p Recognizing your negative thoughts is a huge step forward. It is a key part of improving your mood. Make a plan to try it this week.

        .series-overview
          h3 Categorizing Your Depressive Thoughts
          p Discover the power of labelling to help you understand and challenge negative thoughts.
        ul.series-list
          li
            article.activity
              .ribbon-wrapper
                .ribbon Complete
              img.activity-thumb(src="http://via.placeholder.com/200x200&text=Img" alt="Activity thumbnail")
              h2 Labeling your thoughts
              p Why does labeling help? It lets you see your thoughts more clearly. It gives you the power to accept or reject them.
          li
            article.activity
              img.activity-thumb(src="http://via.placeholder.com/200x200&text=Img" alt="Activity thumbnail")
              h2 Using the thought sorter
              p It&rsquo;s time to practice. This tool helps you label your thoughts.
          li
            article.activity
              .ribbon-wrapper
                .ribbon Completed
              img.activity-thumb(src="http://via.placeholder.com/200x200&text=Img" alt="Activity thumbnail")
              h2 Action plan and summary
              p You&rsquo;re ready to start labeling your thoughts! Can you do it throughout your day?


    .program-heading
      button(@click="showAnx = !showAnx" v-bind:class="{ 'active': showAnx }") Anxiety Program
      .program-progress
        p
          strong 0
          | Complete
        .bar
          span.complete(style="width: 0")
    transition(name="slide-fade")
      .program-content(v-if="showAnx")
        .series-overview
          h3 You Can Do this
          p By starting this series, you're already on the road to feeling better. This section will give you an overview of myStrength's tools for overcoming anxiety.
        ul.series-list
          li
            article.activity
              img.activity-thumb(src="http://via.placeholder.com/200x200&text=Img" alt="Activity thumbnail")
              h2 Getting the most out of this myStrength program
              p Change can be hard. Even more so when you're feeling stressed. Learn how to feel better with myStrength.

    // Placeholders for all other programs
    .program-heading
      button Stress Reduction Program
      .program-progress
        p
          strong 20%
          | Complete
        .bar
          span.complete(style="width: 20%")
    .program-heading
      button Drug or Alcohol Recovery Program
      .program-progress
        p
          strong 10%
          | Complete
        .bar
          span.complete(style="width: 10%")
    .program-heading
      button Chronic Pain Management Program
      .program-progress
        p
          strong 35%
          | Complete
        .bar
          span.complete(style="width: 35%")
    .program-heading
      button Sleep Program
      .program-progress
        p
          strong 100%
          | Complete
        .bar
          // 98 instead of 100 to respect padding of parent
          // Maybe reduce styled width by 2% for all bars?
          span.complete(style="width: 98%")


    hr
</template>

<script>
export default {
  name: 'PatientProgram',
  data() {
    return {
      showDep: false,
      showAnx: false
    };
  }
};
</script>

<style lang="scss" scoped>

  .program-heading {
    padding: $xs-spacing;
    border: 1px solid $md-grey-200;
    background-image: linear-gradient(to bottom, #fff 50%, tint($light-color, 80%));
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
      @include zero;
      display: block;
      position: relative;
      padding-left: 1.5em;
      font-family: $base-font-family;
      font-size: $ms-up1;
      font-weight: $base-font-weight-strong;
      text-transform: uppercase;
      color: $base-font-color;
      &:hover, &:focus {
        color: $action-color;
        outline: none;
      }
      &:after {
        content: '\002B';
        display: block;
        position: absolute;
        background-image: linear-gradient(to top, #fff 50%, tint($light-color, 60%));
        border: 1px solid $md-grey-100;
        @include size($base-font-size);
        font-size: $base-font-size;
        line-height: 1;
        text-align: center;
        border-radius: $base-font-size;
        padding: 0;
        margin: 0;
        left: -2px;
        top: 2px;
        transform-origin: 50% 50%;
        transition: all .25s linear;
      }
    }
    button.active {
      &:after {
        content: '\2212';
        transform: rotate(180deg);
      }
    }

  }
  // TRANSITIONS
  .slide-fade {
    max-height: 0;
    overflow: hidden;
  }
  .slide-fade-enter-active {
    transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-leave-active {
    transition: all .25s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    max-height: 9999em;
    opacity: 0;
  }
  .program-progress {
    p {
      @include zero;
      display: inline-block;
      text-align: right;
      margin-right: 1em;
      font-size: $ms-down1;
      text-transform: uppercase;
    }
    .bar {
      display: inline-block;
      position: relative;
      width: 100px;
      height: 10px;
      background: #fff;
      border: 1px solid tint($success-color, 70%);
      border-radius: 5px;
      box-shadow: inset 0 2px 3px rgba(#000, 0.02);
    }
    .complete {
      position: absolute;
      top: 1px;
      left: 1px;
      height: 6px;
      background: $success-color;
      border-radius: 3px;
    }
  }
  .series-overview {
    position: relative;
    margin: 0 0 0 $small-spacing*1.2;
    padding: $small-spacing;
    padding-left: $base-spacing;
    border-left: 2px solid $light-color;
      &:after {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 0;
        @include size(10px);
        background: $light-color;
        //border-radius: 12px;
        border: 2px solid $light-color;
        margin-left: -8px;
        margin-top: -8px;
      }

    h3, p {
      @include zero;
    }
    h3 {
      font-size: $ms-up2;
    }
    p {
      font-family: $serif-font-family;
    }
  }
  .series-list {
    margin: 0 auto;
    padding-left: $small-spacing*1.2;
    li {
      position: relative;
      margin: 0;
      padding: $xs-spacing $base-spacing;
      max-width: $bp3;
      border-left: 2px solid $light-color;
      &:after {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 0;
        @include size(10px);
        background: #fff;
        border-radius: 12px;
        border: 2px solid $light-color;
        margin-left: -8px;
        margin-top: -8px;
      }
    }
  }
  .activity {
    position: relative;
    padding-left: 100px;
    min-height: 85px;
    h2 {
      @include zero;
    }
  }
  .ribbon-wrapper {
    @include size(85px);
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .ribbon {
    background-color: $success-color;
    box-shadow: 0 0 3px rgba(0,0,0,0.3);
    color: #fff;
    font-size: 0.8em;
    left: -5px;
    line-height: 1.5em;
    padding: 2px 7px;
    position: relative;
    text-align: center;
    top: 15px;
    transform: rotate(45deg);
    width: 120px;
    &.skipped {
      background-color: $alert-color;
      color: $black;
    }
  }
  img.activity-thumb {
    float: left;
    position: relative;
    margin: 0 0 0 -100px;
    @include size(85px);
    border-radius: $base-border-radius;
    @include drop-shadow;
  }

</style>


